/**
 * 简单题 api
 * 简单题 api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';
import CreatedVo from '../../drill/model/CreatedVo';
import DrillQueryForm from '../../drill/model/DrillQueryForm';
import EssayQuestionDrillVo from '../../drill/model/EssayQuestionDrillVo';
import UpdatedVo from '../../drill/model/UpdatedVo';
  /**
   * EssayQuestionDrill service.
   * @module drill/api/EssayQuestionDrillApi
   * @version 0.2.0
   */

  /**
   * Constructs a new EssayQuestionDrillApi. 
   * @alias module:drill/api/EssayQuestionDrillApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;



    /**
     * 创建题目
     * @param {module:drill/model/EssayQuestionDrillVo} body 请求参数body
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.courseStandardId 课程标准id
     * @param {Integer} opts.knowledgeId 知识点id
     * @param {Integer} opts.sectionId 教材小节id
     * @param {Integer} opts.sortKey 云教材小节内题序号
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/CreatedVo}
     */
this.create = function(body, opts) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling create";
      }


      var pathParams = {
      };
      var queryParams = {
        'courseStandardId': opts['courseStandardId'],
        'knowledgeId': opts['knowledgeId'],
        'sectionId': opts['sectionId'],
        'sortKey': opts['sortKey']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = CreatedVo;
      return this.apiClient.callApi(
        '/api/drill/essay_question/', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 查看题目详情
     * @param {Integer} id drill id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/EssayQuestionDrillVo}
     */
this.getDetail = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getDetail";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = EssayQuestionDrillVo;
      return this.apiClient.callApi(
        '/api/drill/essay_question/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 获取题目
     * @param {module:drill/model/DrillQueryForm} body 查询条件
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:drill/model/EssayQuestionDrillVo>}
     */
this.getDrillList = function(body) {
      var postBody = body;

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling getDrillList";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = [EssayQuestionDrillVo];
      return this.apiClient.callApi(
        '/api/drill/essay_question/list', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 删除题目
     * @param {Integer} id id
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/UpdatedVo}
     */
this.removeDrill = function(id) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling removeDrill";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/drill/essay_question/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }


    /**
     * 修改题目
     * @param {Integer} id drill id
     * @param {module:drill/model/EssayQuestionDrillVo} body 请求参数body
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:drill/model/UpdatedVo}
     */
this.update = function(id, body) {
      var postBody = body;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling update";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling update";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var isPublic = false;

      var authNames = [];
      var contentTypes = [];
      var accepts = [];
      var returnType = UpdatedVo;
      return this.apiClient.callApi(
        '/api/drill/essay_question/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType,isPublic
      );
    }
  };

  export default exports;
